const DEFAULT_OPTION = {
  value: "most_popular",
  label: "Most Popular"
};

const SORT_OPTIONS = [
  DEFAULT_OPTION,
  {
    value: "name_a_to_z",
    label: "Name A To Z"
  },
  {
    value: "name_z_to_a",
    label: "Name Z To A"
  },
  {
    value: "highest_discount",
    label: "Highest Discount"
  },
  {
    value: "highest_cash_back",
    label: "Highest Cash Back"
  }
];

export { SORT_OPTIONS, DEFAULT_OPTION };
